/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createItemKeyResultRequestSchema = z.object({
  itemId: z.int(),
  keyResultId: z.int(),
});
